// @flow

import ko from 'rgs-knockout';

import { EventEmitter } from 'events';

export default class RedirectModalModel extends EventEmitter {
	constructor () {
		super();

		this.redirectUrl = ko.observable();

		this.crossingEvent = ko.observable();

		this.openInNewWindow = ko.observable();
	}
}
